export const apiUrl = '/api/v1/';
export const execUrl = '/exec/';

export const updateVersion = 'V1.8.7';

// SaaS / 구축형 여부 0: 구축형 1: Cloud
export let isSaas = 0;
export const changeSaas = saasValue => {
  isSaas = saasValue;
};

// GS인증용 1: gs
export let isGs = 0;
export const changeGS = gsValue => {
  isGs = gsValue;
};

// 일본용 MudFix - 일본용은 config.py 뿐만 아니라 UI에서도 값을 1로 변경해야한다.
export let isJapan = 0;
export const changeJapan = value => {
  isJapan = value;

  // 일본용 버전
  if (value === 1) {
    // ie에서 .jp로 접속 시 ja class 안들어가는 문제
    if (localStorage.getItem('language') === 'ko') {
      window.location.reload();

      localStorage.setItem('language', 'ja');

      document.body.classList.toggle('ja', true);
    }
  }
};


// 영문 버전 사용
export const isEng = 1;

// 경남은행 버전
export const isKNBank = 0;

// 교육관리 탭
export let isEdu = 0;
export const changeEdu = value => {
  isEdu = value;
};

// 신고하기 탭
export let isDeclare = 0;
export const changeDeclare = value => {
  isDeclare = value;
};



// WEBPACK FOOTER //
// ./src/script/libs/commonVar.js